import { Flex } from '@ouster/webviz-react-components';

import AdminOverallOrgsSummary from '../../components/adminDashboard/AdminOverallOrgsSummary';
import AdminOverallSummary from '../../components/adminDashboard/AdminOverallSummary';

export default function OrganizationOverview() {
  return (
    <Flex gap="1rem" height="100%" overflow="hidden" p={4}>
      <AdminOverallSummary />
      <AdminOverallOrgsSummary />
    </Flex>
  );
}
